import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { X } from 'lucide-react';
import type { Dispatch } from 'react';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

type Props = {
  message: string;
  actionMessage: string;
  onClose: Dispatch<unknown>;
  onAction: Dispatch<unknown>;
  icon?: React.ReactNode;
  title?: string;
};

export const NotificationContainer = ({
  message,
  actionMessage,
  onClose,
  onAction,
  icon,
  title
}: Props) => {
  return (
    <div className="fancy-brand-gradient align-center flex w-full flex-row justify-between rounded-xl px-5 py-4">
      <div className="flex flex-row items-center gap-2 text-black">
        {icon ? icon : <InformationCircleIcon className="size-5" />}
        <div>
          {title && <div className="font-bold">{title}</div>}
          <div>{message}</div>
        </div>
      </div>
      <div className="align-center flex flex-row items-center justify-center gap-2 text-center">
        <PrimaryButton
          onClick={onAction}
          className="whitespace-nowrap !bg-action-primary !text-white hover:!bg-action-primary-hover [&:active]:!bg-action-primary-active"
        >
          {actionMessage}
        </PrimaryButton>
        <X onClick={onClose} />
      </div>
    </div>
  );
};
